export default __webpack_public_path__ + "static/media/spinner.022e5e25.png";